"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkAudioDevice = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}; // 检查录音设备是否正常


var checkAudioDevice = function checkAudioDevice() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var stream;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
              _context.next = 16;
              break;
            }

            _context.prev = 1;
            _context.next = 4;
            return navigator.mediaDevices.getUserMedia({
              audio: true
            });

          case 4:
            stream = _context.sent;
            stream.getTracks().forEach(function (item) {
              item.stop();
            });
            console.log('【组件库】用户录音设备正常');
            return _context.abrupt("return", true);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            console.error('【组件库】输入输出设备异常', _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message);
            return _context.abrupt("return", false);

          case 14:
            _context.next = 17;
            break;

          case 16:
            return _context.abrupt("return", false);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 10]]);
  }));
};

exports.checkAudioDevice = checkAudioDevice;